import React from 'react';
export function Footer() {
  return <footer className="bg-navy-dark py-12 text-center text-white/50 text-sm" data-id="element-31">
      <div className="max-w-4xl mx-auto px-4" data-id="element-32">
        <p className="font-serif text-xl text-white/80 mb-4" data-id="element-33">
          Cero Niebla Mental
        </p>
        <p className="mb-6 max-w-2xl mx-auto leading-relaxed" data-id="element-34">
          Este producto no sustituye el consejo médico profesional, diagnóstico
          o tratamiento. Siempre busque el consejo de su médico u otro proveedor
          de salud calificado con cualquier pregunta que pueda tener sobre una
          condición médica.
        </p>
        <p data-id="element-35">
          &copy; {new Date().getFullYear()} Cero Niebla Mental. Todos los
          derechos reservados.
        </p>
      </div>
    </footer>;
}